/* eslint-disable prefer-template */
const roundDecimal = (type, value, exp) => {
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;

  if (Number.isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }

  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
};

const round = (value, exp = -2) => {
  return roundDecimal('round', value, exp);
};

const ceil = (value, exp = -2) => {
  return roundDecimal('ceil', value, exp);
};

const floor = (value, exp = -2) => {
  return roundDecimal('floor', value, exp);
};

export { round, ceil, floor };
